import { render, staticRenderFns } from "./role-login.vue?vue&type=template&id=42b2d994&scoped=true&"
import script from "./role-login.vue?vue&type=script&lang=js&"
export * from "./role-login.vue?vue&type=script&lang=js&"
import style0 from "./role-login.vue?vue&type=style&index=0&id=42b2d994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b2d994",
  null
  
)

export default component.exports